// extracted by mini-css-extract-plugin
module.exports = {"StatsPiechart":"StatsPiechart_StatsPiechart__ZArpg","percentage":"StatsPiechart_percentage__j1AW7","pie":"StatsPiechart_pie__M4UL9","flip":"StatsPiechart_flip__xpyv4"};